import { InputNumber, Select as AntSelect } from "antd";
import { get, isNil } from "lodash";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import { NODE_TYPES } from "utils/constants";
import CanvasIcon from "./CanvasIcon";
import { DELAY_UNITS, splitDelay, toSeconds } from "./next-steps";
import { ICON_PATHS, stepLook } from "./step-look";

const WaitTab = ({ node, onChange, onShowNext }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.PROCESS);
  const WAIT = t("CANVAS_EDITOR.STEP.WAIT", { returnObjects: true });
  const UNITS = t("CANVAS_EDITOR.NEXT.UNITS", { returnObjects: true });

  const data = node.data || {};
  const nodeType = data.nodeType;
  const config = data.config || {};
  const delay = isNil(get(config, "delaySeconds"))
    ? { value: null, unit: DELAY_UNITS.DAYS }
    : splitDelay(config.delaySeconds);
  const unitOptions = Object.values(DELAY_UNITS).map((unit) => ({
    value: unit,
    label: UNITS[unit],
  }));

  const setDelay = (seconds) =>
    onChange("config", { ...config, delaySeconds: seconds });

  return (
    <div className="canvas-tab">
      <section className="canvas-wait">
        <div className="canvas-wait__head">
          <span className="canvas-wait__icon">
            <CanvasIcon path={stepLook(nodeType).icon} size={22} />
          </span>
          <div className="canvas-wait__text">
            <strong>{get(WAIT, ["WAITS_FOR", nodeType])}</strong>
            <span>{get(WAIT, ["RESUMES", nodeType])}</span>
          </div>
        </div>
        {nodeType === NODE_TYPES.TIMER ? (
          <div className="canvas-wait__delay">
            <span>{WAIT.DURATION}</span>
            <InputNumber
              min={1}
              precision={0}
              aria-label={WAIT.DURATION}
              value={delay.value || null}
              onChange={(value) => setDelay(toSeconds(value, delay.unit))}
            />
            <AntSelect
              virtual={false}
              className="canvas-wait__unit"
              aria-label={WAIT.UNIT}
              options={unitOptions}
              value={delay.unit}
              onChange={(unit) => setDelay(toSeconds(delay.value || 1, unit))}
            />
          </div>
        ) : null}
        <div className="canvas-wait__note">
          <CanvasIcon path={ICON_PATHS.clock} strokeWidth={2} />
          <span>{WAIT.NO_DELAY}</span>
        </div>
        <button
          type="button"
          className="canvas-wait__next"
          onClick={onShowNext}
        >
          {WAIT.SEE_NEXT}
        </button>
      </section>
    </div>
  );
};

WaitTab.propTypes = {
  node: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onShowNext: PropTypes.func.isRequired,
};

export default WaitTab;
